import {HowItWorksVideo} from "../../../../../../portal-latvia/src/public/page/HowItWorksPage";

export let HowItWorksVideoStoryblokComponent = ({blok}) => {
    return <HowItWorksVideo />
}